/**
 * Task 17: Layout wrapper with vertical sidebar
 * Replaces horizontal navbar with collapsible sidebar
 */

import { useState } from 'react';
import Sidebar from './Sidebar';

export default function Layout({ children }) {
  const [sidebarCollapsed, setSidebarCollapsed] = useState(false);
  
  return (
    <div className="flex min-h-screen bg-navy">
      {/* Sidebar */}
      <Sidebar collapsed={sidebarCollapsed} onToggle={setSidebarCollapsed} />
      
      {/* Main Content */}
      <div 
        className={`flex-1 transition-all duration-300 ease-in-out ${
          sidebarCollapsed ? 'ml-20' : 'ml-64'
        }`}
      >
        {/* Content Area */}
        <main className="p-6">
          {children}
        </main>
        
        {/* Footer */}
        <footer className="bg-navy-dark border-t border-teal/30 mt-12">
          <div className="max-w-7xl mx-auto px-6 py-4">
            <p className="text-center text-sm text-textLight/60 font-body">
              Spes Recruiter App © 2025 - Built with React + FastAPI
            </p>
          </div>
        </footer>
      </div>
    </div>
  );
}
